import { apiClient } from './client';
import type { AdProvider, DictQuery, PageData } from './types';

export interface CreateAdProviderReq {
  providerCode: string;
  providerName: string;
  businessEntity?: string;
  status?: 0 | 1;
  remark?: string;
}

export async function listAdProviders(params: DictQuery = {}): Promise<PageData<AdProvider>> {
  const res = await apiClient.get<PageData<AdProvider>>('/ads-admin/ad-providers', { params });
  return res.data;
}

export async function createAdProvider(req: CreateAdProviderReq): Promise<AdProvider> {
  const res = await apiClient.post<AdProvider>('/ads-admin/ad-providers', req);
  return res.data;
}

export async function updateAdProvider(
  providerId: number,
  req: CreateAdProviderReq,
): Promise<AdProvider> {
  const res = await apiClient.put<AdProvider>(`/ads-admin/ad-providers/${providerId}`, req);
  return res.data;
}

export async function setAdProviderStatus(providerId: number, status: 0 | 1): Promise<void> {
  await apiClient.put(`/ads-admin/ad-providers/${providerId}/status`, { status });
}
